import React from 'react';
import PropTypes from 'prop-types';

const DishWasherNot = ({ color = '#BCC6CA', lineColor = '#fff', ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" viewBox="0 0 24 24" {...props}>
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.8}
      d="M7.25 22H4.889c-.501 0-.982-.234-1.336-.65A2.436 2.436 0 0 1 3 19.777V4.222c0-.59.199-1.154.553-1.571C3.907 2.234 4.388 2 4.89 2H18.11c.501 0 .982.234 1.336.65.354.418.553.983.553 1.572v15.556c0 .59-.199 1.154-.553 1.571-.354.417-.835.651-1.336.651H15.75M20 6.444H3m8.5 10V22m0 0H9.611m1.889 0h1.889"
    />
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.8}
      d="m17.167 4.233.01-.012m-2.844.012.01-.012M11.5 16.445c1.565 0 2.833-1.658 2.833-3.704v-.534H8.667v.534c0 2.045 1.268 3.704 2.833 3.704Z"
    />
    <rect width={5} height={1.5} x={5} y={3.5} stroke={color} strokeWidth={0.7} rx={0.5} />
    <rect
      width={1.5}
      height={28.638}
      x={1.354}
      y={2.414}
      fill={color}
      stroke={lineColor}
      strokeWidth={0.5}
      rx={0.75}
      transform="rotate(-45 1.354 2.414)"
    />
  </svg>
);

DishWasherNot.propTypes = {
  color: PropTypes.string,
  lineColor: PropTypes.string
};

export default DishWasherNot;
